import { Tooltip } from 'bold-ui'
import { PageLoading } from 'components/loading'
import React, { MouseEventHandler } from 'react'

export interface ContentCardSectionProps {
  children: React.ReactNode
  tooltip?: string
  isLoading?: boolean
  messageLoading?: string
  onClick?: MouseEventHandler<HTMLDivElement>
}

export function ContentCardSection(props: ContentCardSectionProps) {
  const { onClick } = props
  return (
    <>
      {props.isLoading && <PageLoading message={props.messageLoading || 'Carregando dados'} />}
      {!props.isLoading && (
        <Tooltip text={props.tooltip} placement='top-end'>
          <div style={{ padding: '0.5rem', cursor: onClick && 'pointer' }} onClick={onClick}>
            {props.children}
          </div>
        </Tooltip>
      )}
    </>
  )
}
